"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.makeBoid = exports.defaultConfig = void 0;
var p5 = __importStar(require("p5"));
var p5_1 = require("p5");
exports.defaultConfig = {
    r: 1.0,
    maxspeed: 1.2,
    maxforce: 0.25,
    coheisionDistance: 50,
};
var defaultRunConfig = {
    width: 100,
    height: 100,
    depth: 50
};
var makeBoid = function (pos, velocity, acceleration, config, runConfig) {
    if (config === void 0) { config = exports.defaultConfig; }
    if (runConfig === void 0) { runConfig = defaultRunConfig; }
    /////////////////////////////////////// function begins ///////////////
    var _pos = pos;
    var _velocity = velocity;
    var _bounceBorders = true;
    // run config
    var width = runConfig.width, height = runConfig.height, depth = runConfig.depth;
    var _width = width;
    var _height = height;
    var _depth = depth;
    var _config = __assign(__assign({}, exports.defaultConfig), config);
    var r = _config.r, maxspeed = _config.maxspeed, maxforce = _config.maxforce, coheisionDistance = _config.coheisionDistance;
    var _coheisionDistance = coheisionDistance;
    var _maxspeed = maxspeed;
    var _maxforce = maxforce;
    return __assign(__assign({ acceleration: acceleration }, __assign({ defaultConfig: exports.defaultConfig }, config)), { 
        //// RUN
        run: function (boids, runConfig) {
            var width = runConfig.width, height = runConfig.height, depth = runConfig.depth;
            _width = width;
            _height = height;
            _depth = depth;
            this.flock(boids);
            this.borders();
            this.update();
        }, applyForce: function (force) {
            this.acceleration.add(force);
        }, 
        ///// SEPERATE
        separate: function (boids) {
            var desiredseparation = 25.0;
            var steer = new p5_1.Vector();
            steer.set(0, 0, 0);
            var count = 0;
            // For every boid in the system, check if it's too close
            for (var i = 0; i < boids.length; i++) {
                var d = new p5_1.Vector();
                d.set(0, 0, 0);
                var distance = _pos.dist(boids[i].getPosition());
                // If the distance is greater than 0 and less than an arbitrary amount (0 when you are yourself)
                if ((distance > 0) && (distance < desiredseparation)) {
                    // Calculate vector pointing away from neighbor
                    var diff = p5_1.Vector.sub(_pos, boids[i].getPosition());
                    diff.normalize();
                    diff.div(distance); // Weight by distance
                    steer.add(diff);
                    count++; // Keep track of how many
                }
            }
            // Average -- divide by how many
            if (count > 0) {
                steer.div(count);
            }
            // As long as the vector is greater than 0
            if (steer.mag() > 0) {
                // Implement Reynolds: Steering = Desired - Velocity
                steer.normalize();
                steer.mult(_maxspeed);
                steer.sub(_velocity);
                steer.limit(_maxforce);
            }
            return steer;
        }, 
        //// ALIGN
        align: function (boids) {
            var neighbordist = 150;
            var sum = new p5_1.Vector();
            sum.set(0, 0, 0);
            var count = 0;
            for (var i = 0; i < boids.length; i++) {
                var d = _pos.dist(boids[i].getPosition());
                if ((d > 0) && (d < neighbordist)) {
                    sum.add(boids[i].velocity);
                    count++;
                }
            }
            if (count > 0) {
                sum.div(count);
                sum.normalize();
                sum.mult(_maxspeed);
                var steer = p5_1.Vector.sub(sum, this.velocity);
                steer.limit(_maxforce);
                return steer;
            }
            else {
                var steer = new p5_1.Vector();
                steer.set(0, 0, 0);
                return steer;
            }
        }, 
        //// COHEASON
        cohesion: function (boids) {
            var sum = new p5_1.Vector();
            sum.set(0, 0, 0);
            // Start with empty vector to accumulate all locations
            var count = 0;
            for (var i = 0; i < boids.length; i++) {
                var d = _pos.dist(boids[i].getPosition());
                if ((d > 0) && (d < _coheisionDistance)) {
                    sum.add(boids[i].getPosition()); // Add location
                    count++;
                }
            }
            if (count > 0) {
                sum.div(count);
                var seeker = this.seek(sum);
                return seeker; // Steer towards the location
            }
            else {
                var sum_1 = new p5_1.Vector();
                sum_1.set(0, 0, 0);
                return sum_1;
            }
        }, 
        //// FLOCK
        flock: function (boids) {
            var sep = this.separate(boids); // Separation
            var ali = this.align(boids); // Alignment
            var coh = this.cohesion(boids); // Cohesion
            // Arbitrarily weight these forces
            sep.mult(1.5);
            ali.mult(1.0);
            coh.mult(1.0);
            // Add the force vectors to acceleration
            this.applyForce(sep);
            this.applyForce(ali);
            this.applyForce(coh);
        }, 
        ///// SEEK
        seek: function (targ) {
            //
            var desired = p5_1.Vector.sub(targ, _pos); // A vector pointing from the location to the target
            // Normalize desired and scale to maximum speed
            desired.normalize();
            desired.mult(_maxspeed);
            // Steering = Desired minus Velocity
            var steer = p5_1.Vector.sub(desired, _velocity);
            steer.limit(_maxforce); // Limit to maximum steering force
            return steer;
        }, 
        /// BORDERS
        borders: function () {
            if (_bounceBorders) {
                if (_pos.x < -r) {
                    _pos.x = r;
                    _velocity.x *= -1;
                }
                if (_pos.y < -r) {
                    _pos.y = r;
                    _velocity.y *= -1;
                }
                /////////
                if (_pos.z < -r) {
                    _pos.z = r;
                    _velocity.z *= -1;
                }
                //////// ------------- ////////
                //////// ------------- ////////
                if (_pos.x > _width + r) {
                    _pos.x = _width - r;
                    _velocity.x *= -1;
                }
                if (_pos.y > _height + r) {
                    _pos.y = _height - r;
                    _velocity.y *= -1;
                }
                ////////
                if (_pos.z > _depth + r) {
                    _pos.z = _depth - r;
                    _velocity.z *= -1;
                }
            }
            else {
                if (_pos.x < -r)
                    _pos.x = _width + r;
                if (_pos.y < -r)
                    _pos.y = _height + r;
                if (_pos.z < -r)
                    _pos.z = _depth + r;
                if (_pos.x > _width + r)
                    _pos.x = -r;
                if (_pos.y > _height + r)
                    _pos.y = -r;
                if (_pos.z > _depth + r)
                    _pos.z = -r;
            }
        }, 
        /// UPDATE
        update: function () {
            // Update velocity
            _velocity.add(this.acceleration);
            // Limit speed
            _velocity.limit(_maxspeed);
            _pos.add(_velocity);
            // Reset accelertion to 0 each cycle
            this.acceleration.mult(0);
            _pos = _pos.add(_velocity);
        }, getPosition: function () {
            return _pos;
        }, setPosition: function (value) {
            _pos = value;
        }, get velocity() {
            return _velocity;
        },
        set velocity(value) {
            _velocity = value;
        }, 
        //=== PUBLIC API ====
        setCohesionDistance: function (value) {
            _coheisionDistance = value;
        }, getCohesionDistance: function () {
            return _coheisionDistance;
        }, setMaxSpeed: function (value) {
            _maxspeed = value;
        }, getMaxSpeed: function () {
            return _maxspeed;
        }, setMaxForce: function (value) {
            _maxforce = value;
        }, getMaxForce: function () {
            return _maxforce;
        } });
};
exports.makeBoid = makeBoid;
var create = function (pos, config) {
    if (pos === void 0) { pos = [10, 10, 0]; }
    if (config === void 0) { config = {}; }
    var x = pos[0], y = pos[1], z = pos[2];
    var startPos = new p5.Vector();
    startPos.set(x, y, z);
    var vel = p5.Vector.random3D();
    var acc = p5.Vector.random3D();
    var boidConfig = __assign(__assign({}, exports.defaultConfig), config);
    return (0, exports.makeBoid)(startPos, vel, acc, boidConfig);
};
exports.create = create;
